import React, { useState } from "react";

const cyan = "#0505A9";
const white = "#FFFFFF";
const borderW = 2;
const numOfBlobs = 4;

const BlobButton = ({label}) => {
  const [hovered, setHovered] = useState(false);

  const blobBtnStyle = {
    position: "relative",
    padding: "20px 46px",
    // marginBottom: "30px",
    textAlign: "center",
    textTransform: "uppercase",
    color: hovered ? white : 'rgb(40 120 160)',
    fontSize: "16px",
    fontWeight: "bold",
    backgroundColor: "transparent",
    outline: "none",
    border: "none",
    cursor: "pointer",
    borderRadius: "30px",
    overflow: "hidden",
  };

  const beforeStyle = {
    content: '""',
    zIndex: 1,
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    border: `${borderW}px solid rgb(40 120 160);`,
    borderRadius: "30px",
    pointerEvents: "none",
  };

  const afterStyle = {
    content: '""',
    zIndex: -2,
    position: "absolute",
    left: hovered ? 0 : `${borderW * 1.5}px`,
    top: hovered ? 0 : `${borderW * 1.5}px`,
    width: "100%",
    height: "100%",
    borderRadius: "30px",
    backgroundColor: "#fff",
    transition: "all 0.3s",
  };

  const innerStyle = {
    zIndex: -1,
    overflow: "hidden",
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    borderRadius: "30px",
    background: "#fff",
  };

  const blobsContainerStyle = {
    position: "relative",
    display: "block",
    height: "100%",
    filter: "url('#goo')",
  };

  const blobStyle = (i) => ({
    position: "absolute",
    top: `${borderW}px`,
    left: `${(i * 120) / numOfBlobs}%`,
    width: `${100 / numOfBlobs}%`,
    height: "100%",
    background: 'rgb(40 120 160)',
    borderRadius: "100%",
    transform: hovered
      ? "translateZ(0) scale(1.4)"
      : "translate3d(0,150%,0) scale(1.4)",
    transition: "transform 0.45s",
    transitionDelay: `${i * 0.08}s`,
  });

  return (
    <div style={{ marginTop: "50px", textAlign: "center" }}>
      <button
        style={blobBtnStyle}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {label}
        <span style={beforeStyle}></span>
        <span style={afterStyle}></span>
        <span style={innerStyle}>
          <span style={blobsContainerStyle}>
            {[...Array(numOfBlobs)].map((_, i) => (
              <span key={i} style={blobStyle(i)}></span>
            ))}
          </span>
        </span>
      </button>

      {/* SVG Filter Definition */}
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" style={{ display: "none" }}>
        <defs>
          <filter id="goo">
            <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="10" />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 21 -7"
              result="goo"
            />
            <feBlend in="SourceGraphic" in2="goo" result="mix" />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default BlobButton;
